import React from 'react';

const LoadingSpinner = () => (
  <div>
    <i className="fa fa-spinner fa-spin" /> Fetching data...
  </div>
);

export default LoadingSpinner;
